import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import translate from '../../translate';

function AgendaEvent(props) {
  const { event } = props;
  return (
    <div className="event-of-agenda">
      <div className="circle" />
      <span className="hours">{moment(event?.startDate).format('HH:mm')}</span>
      <span className="name">{event.name}</span>
    </div>
  );
}

AgendaEvent.propTypes = {
  event: PropTypes.shape({
    startDate: PropTypes.number,
    name: PropTypes.string,
  }),
};

AgendaEvent.defaultProps = {
  event: {
    startDate: null,
    name: '',
  },
};

export default translate(AgendaEvent);
